import React from "react";
import { EmteriaRoles } from "src/data/roles";
import { ListResponse } from "src/types";

import { fetchRoles } from "@admin/api/account";
import { showErrorToast } from "@shared/toasts/Toasts";

export const useFetchRoles = () => {
    const [data, setData] = React.useState<EmteriaRoles[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);

    const onSuccess = (response: ListResponse<EmteriaRoles>) => {
        setData(response.list);
    };
    const onError = (error: Error) => {
        showErrorToast(error.message);
    };

    React.useEffect(() => {
        setIsLoading(true);
        void fetchRoles()
            .then(onSuccess)
            .catch(onError)
            .finally(() => setIsLoading(false));
    }, []);

    return { data, isLoading };
};
